/**
 * Response modifier for getJournalEntry.
 *
 * Currently a passthrough — reserved for future response transformations.
 */

interface AxiosResponse {
  data: unknown;
  [key: string]: unknown;
}

export function jeResponseModifier(resp: AxiosResponse): AxiosResponse {
  return resp;
}
